<script>
import moment from "moment";
export default {
  data() {//Declaracao de variaveis
    return {};
  },

  computed: {//Campos computados
    analisaNovoModel() {
      return this.model;
    },

    analisaOldModel() {
      return this.OldModel;
    },

    _enums() {
      return this.enums;
    }
  },
  methods: {//Declaracao de todos os metodos
    _ifValueAlterado(newValue, oldValue, aliasValor) {
      var novo = String(newValue).trim();
      if (novo == "") {
        novo = null;
      }

      if (
        this.analisaNovoModel.tipoSolicitacao === 2 &&
        String(novo).trim() != String(oldValue).trim() &&
        String(novo).trim() != "Não Encontrado" &&
        String(oldValue).trim() != "Não Encontrado"
      ) {
        if (aliasValor) {
          oldValue = aliasValor;
        }  
        //let msg =  `<span class='tooltipHint'> * Campo Alterado 77777  </span>`;
        let msg =  `* Campo Alterado`;
        return msg;        
          
        
      }
      return "";
    },

    ifValueAlterado(valorAtual, prop, aliasValor) {
      var retorno = "";
      if (this.analisaOldModel && Object.keys(this.analisaOldModel).length) {
        retorno = this._ifValueAlterado(
          valorAtual,
          this.analisaOldModel[prop],
          aliasValor
        );
      }
      return retorno;
    },

    ifValueAlteradoSemMask(valorAtual, prop, aliasValor) {
      var retorno = "";
      if (this.analisaOldModel && Object.keys(this.analisaOldModel).length) {
        var vNew = String(valorAtual).replace(/[^a-z0-9]+|\s+/g, "");
        var vpOld = String(this.analisaOldModel[prop]).replace(
          /[^a-z0-9]+|\s+/g,
          ""
        );
        retorno = this._ifValueAlterado(vNew, vpOld, aliasValor);
      }
      return retorno;
    },

    ifDataAlterado(valorAtual, prop) {
      var retorno = "";
      if (this.analisaOldModel && Object.keys(this.analisaOldModel).length) {
        var dataNew = moment(valorAtual).format("YYYY-MM-DD");
        var dataOld = this.analisaOldModel[prop]
          ? moment(this.analisaOldModel[prop]).format("YYYY-MM-DD")
          : null;
        retorno = this._ifValueAlterado(
          dataNew,
          dataOld,
          dataOld ? moment(dataOld).format("DD/MM/YYYY") : null
        );
      }
      return retorno;
    },

    ifDataDocumentoAlterado(valorAtual, prop, codDocumento) {
      var retorno = "";
      var oldDocumento = null;
      if (this.analisaOldModel && Object.keys(this.analisaOldModel).length && this.analisaOldModel.documentosSolicitacao) {
        var oldDoc = this.analisaOldModel.documentosSolicitacao.filter(documento => documento.codDocumento === codDocumento);
        if(oldDoc.length > 0){
          oldDocumento = oldDoc[0];

          var dataNew = (valorAtual != null) ?  moment(valorAtual).format("YYYY-MM-DD") : null;
          var dataOld = oldDocumento[prop]
            ? moment(oldDocumento[prop]).format("YYYY-MM-DD")
            : null;
          retorno = this._ifValueAlterado(
            dataNew,
            dataOld,
            dataOld ? moment(dataOld).format("DD/MM/YYYY") : null
          );
        }
      }
      return retorno;
    },
    ifValueDocumentoAlterado(valorAtual, prop, codDocumento, aliasValor) {
      var retorno = "";
      var oldDocumento = null;
      if (this.analisaOldModel && Object.keys(this.analisaOldModel).length && this.analisaOldModel.documentosSolicitacao) {
        var oldDoc = this.analisaOldModel.documentosSolicitacao.filter(documento => documento.codDocumento === codDocumento);
        if(oldDoc.length > 0){
          oldDocumento = oldDoc[0];

          retorno = this._ifValueAlterado(
            valorAtual,
            oldDocumento[prop],
            aliasValor
          );
        }

      }
      return retorno;
    },
    ifDocAlterado(entidade, propPesquisa, codDoc, valorAtual, prop) {
      var retorno = "";
      if (
        this.analisaOldModel[entidade] &&
        this.analisaOldModel[entidade].length
      ) {
        var oldEnt = this.analisaOldModel[entidade].find(
          x => x[propPesquisa] === codDoc
        );

        retorno = this._ifValueAlterado(
          valorAtual,
          oldEnt ? oldEnt[prop] : null
        );
      }
      return retorno;
    },

    ifHabilitacaoJuridicaAlterado(codDoc, valorAtual, prop) {
      var retorno = "";
      if (
        this.analisaOldModel["fornecedoresHabilitacaoJuridica"] &&
        this.analisaOldModel["fornecedoresHabilitacaoJuridica"].length
      ) {
        var oldEnt = this.analisaOldModel.fornecedoresHabilitacaoJuridica.find(
          x => String(x.cpfCnpj).trim() === String(codDoc).trim()
        );
        if (oldEnt) {
          var aliasValor = null;
          switch (prop) {
            case "flagEstrangeiro":
              aliasValor = oldEnt[prop] ? "Sim" : "Não";
              break;
          }
          retorno = this._ifValueAlterado(
            valorAtual,
            oldEnt[prop],
            aliasValor
          );
        }
      }

      return retorno;
    },

    ifHabilitacaoJuridicaNova(codDoc, tipoCadastro) {
      var retorno =
        "<span style='color:#FF9800'>*Novo " +
        (tipoCadastro === "D" ? "Dirigente" : "Sócio") +
        "</span>";

      if (
        this.analisaOldModel["fornecedoresHabilitacaoJuridica"] &&
        this.analisaOldModel["fornecedoresHabilitacaoJuridica"].length
      ) {
          
        var oldEnt = this.analisaOldModel.fornecedoresHabilitacaoJuridica.find(
          x => String(x.cpfCnpj).trim() === String(codDoc).trim()
        );
        if (!oldEnt) {
          return retorno;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    ifNovafamilia(codGrupo, numFamilia) {
      var retorno = "";
      if (
        this.analisaOldModel["familiaSolicitacao"] &&
        this.analisaOldModel["familiaSolicitacao"].length
      ) {
        var oldEnt = this.analisaOldModel.familiaSolicitacao.find(
          x => x.codGrupo === codGrupo && x.numFamilia === numFamilia
        );
        if (!oldEnt)
          retorno = "<span style='color:#FF9800'>*Nova Família</span>";
      }
      return retorno;
    },

    ifAnexoFamiliaAlterado(codGrupo, numFamilia,anexoFamiliaAtual){
      var retorno = "";
      if (
        this.analisaOldModel["familiaSolicitacao"] &&
        this.analisaOldModel["familiaSolicitacao"].length
      ) {
        var oldEnt = this.analisaOldModel.familiaSolicitacao.find(
          x => x.codGrupo === codGrupo && x.numFamilia === numFamilia && x.anexoFamilia != null
        );
        if (oldEnt && anexoFamiliaAtual)
        {
          var oldValue = oldEnt["anexoFamilia"]["arquivoUpload"];
          var newValue = anexoFamiliaAtual["arquivoUpload"];
          retorno = this._ifValueAlterado(newValue, oldValue);
        }
      }
      return retorno;
    },

    ifQualificacaoAlterado(codDoc, valorAtual, prop, isCampoData) {
      var retorno = "";
      if (
        this.analisaOldModel["qualificacaoTecnica"] &&
        this.analisaOldModel["qualificacaoTecnica"].length
      ) {
        var oldEnt = this.analisaOldModel.qualificacaoTecnica.find(
          x => x.codDocumento === codDoc
        );
        if (oldEnt) {
          var oldValue = oldEnt[prop];
          if (isCampoData && oldValue) {
            oldValue = moment(oldValue).format("DD/MM/YYYY");
            valorAtual = moment(valorAtual).format("DD/MM/YYYY");
          }

          retorno = this._ifValueAlterado(valorAtual, oldValue);
        }
      }
      return retorno;
    },

    ifConcordataFalenciaAlterado(valorAtual, prop, isCampoData) {
      var retorno = "";
      if (
        this.analisaOldModel &&
        this.analisaOldModel.concordataFalencia &&
        Object.keys(this.analisaOldModel.concordataFalencia).length
      ) {
        var oldEnt = this.analisaOldModel.concordataFalencia;
        var oldValue = oldEnt ? oldEnt[prop] : null;
        if (isCampoData && oldValue) {
          oldValue = moment(oldValue).format("DD/MM/YYYY");
          valorAtual = moment(valorAtual).format("DD/MM/YYYY");
        }
        var aliasValor = null;

        switch (prop) {
          case "situacaoDoc":
            var desc = this._enums.situacaoDoc.find(x => x.valor === oldValue);
            if (desc) {
              aliasValor = desc.descricao;
            }
            break;
        }

        retorno = this._ifValueAlterado(valorAtual, oldValue, aliasValor);
      }
      return retorno;
    },

    ifuploadDeclaracaoAlterado(valorAtual, codDocumento, prop) {
      var retorno = this.ifNovoDocumento("uploadDeclaracao", codDocumento, prop);
      if (retorno === "" && this.analisaNovoModel.tipoSolicitacao===2) {
        var oldValue = this.OldModel.uploadDeclaracao.find(
          x => x.tipDocumento === codDocumento
        );
        if (oldValue) {
          oldValue = oldValue.arquivoUpload;
        }
        retorno = this._ifValueAlterado(valorAtual, oldValue);
      }
      return retorno;
    },

    ifBalancoFinanceiroMoedaAlterado(valorAtual, prop) {
      return this.ifBalancoFinanceiroAlterado(valorAtual, prop, false, true);
    },

    ifBalancoFinanceiroDataAlterado(valorAtual, prop) {
      return this.ifBalancoFinanceiroAlterado(valorAtual, prop, true, false);
    },

    ifBalancoFinanceiroAlterado(valorAtual, prop, isCampoData, isMoeda) {
      var retorno = "";

      if (
        this.analisaOldModel &&
        this.analisaOldModel.balancoFinanceiro &&
        Object.keys(this.analisaOldModel.balancoFinanceiro).length
      ) {
        var oldEnt = this.analisaOldModel.balancoFinanceiro;
        var oldValue = oldEnt ? oldEnt[prop] : null;
        if (isCampoData && oldValue) {
          oldValue = moment(oldValue).format("DD/MM/YYYY");
          valorAtual = moment(valorAtual).format("DD/MM/YYYY");
        } else {
          if (isMoeda) {
            valorAtual = this.formatarNumero(Number(valorAtual));
            oldValue = this.formatarNumero(Number(oldValue));
          }
        }
        retorno = this._ifValueAlterado(valorAtual, oldValue);
      }
      return retorno;
    },

    ifRegularidadeFiscalAlterado(tipDocumento, valorAtual, prop, isCampoData) {
      var retorno = "";
      if (
        this.analisaOldModel["regularidadeFiscTrab"] &&
        this.analisaOldModel["regularidadeFiscTrab"].length
      ) {
        var oldEnt = this.analisaOldModel.regularidadeFiscTrab.find(
          x => x.tipDocumento === tipDocumento
        );
        if (oldEnt) {
          var oldValue = oldEnt[prop];
          if (isCampoData && oldValue) {
            oldValue = moment(oldValue).format("DD/MM/YYYY");
            valorAtual = moment(valorAtual).format("DD/MM/YYYY");
          }

          var aliasValor = null;

          switch (prop) {
            case "situacaoDoc":
              var desc = this._enums.situacaoDoc.find(x => x.valor === oldValue);
              if (desc) {
                aliasValor = desc.descricao;
              }
              break;
          }

          retorno = this._ifValueAlterado(valorAtual, oldValue, aliasValor);
      
          if(valorAtual == "integracao")
          {return false;}
        }
      }
      return retorno;
    },

  /*
    retornaAliasSituacaoDoc(intSituacaoDoc) {
      var aliasValor = null;

      switch (intSituacao) {
        case "situacaoDoc":
          if (oldValue === 1) {
            aliasValor = "Negativa";
          }
          if (oldValue === 2) {
            aliasValor = "Positiva com efeito de Negativa";
          }
          break;
      }
      return aliasValor
    },
  */
    ifNovoDocumento(entidade, codDocumento, prop) {
      var retorno = "";
      if (!this.ifDocJaCadastrado(entidade, codDocumento, prop) && this.analisaNovoModel.tipoSolicitacao===2) {
        /*
          Após a versão 1.5.20 do Vue a Propriedade Hint não renderisa Html/CSS
        */
        //retorno = "<span style='color:#FF9800'>*Novo Documento</span>";
        retorno = "*Novo Documento";
      }
      return retorno;
    },

    ifDocJaCadastrado(entidade, codDocumento, prop) {
      if (this.analisaNovoModel.tipoSolicitacao===2 && this.analisaOldModel[entidade] &&  this.analisaOldModel[entidade].length) {
        prop = prop ? prop : "codDocumento";

        var oldEnt = this.analisaOldModel[entidade].find(x => x[prop] === codDocumento);
        if (!oldEnt) return false;
      } else {
        return false;
      }
      return true;
    },
    formatarNumero(valor, percent) {
      return (
        (!percent ? "R$ " : "") +
        valor.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) +
        (percent ? "%" : "")
      );
    }
  }
};
</script>

<style>
.v-text-field__details:hover {
  overflow: inherit !important;
  display: block;
}

.tooltipHint {
  position: relative;
  color: #ff9800;
  cursor: pointer;
  display: block;
}

.tooltipHint .tooltipHinttext {
  visibility: hidden;
  display: block;
  padding: 5px 10px;
  background-color: #349fbe;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
}
.tooltipHint:hover .tooltipHinttext {
  visibility: visible;
}

.tableAprovarRejeitar .v-table__overflow {
  padding-bottom: 10px;
}
</style>